module.exports = __webpack_public_path__ + "static/img/Kate.42f386c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/photos/testimonials/ats/Kate.png
// module id = HDH6
// module chunks = 0